import React from 'react';

const ConfirmLogoutModal = ({ isOpen, onClose, onConfirm, isLoading }) => {
    // Prevent background scrolling
    React.useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[110] flex items-center justify-center bg-black/80 backdrop-blur-md animate-premium-fade p-4">
            <div className="bg-gray-800 rounded-xl border border-white/5 w-full max-w-sm overflow-hidden shadow-2xl animate-premium-in m-4">
                <div className="p-6 text-center">
                    <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className={`ri-logout-box-r-line text-3xl text-red-500 ${isLoading ? 'animate-pulse' : ''}`}></i>
                    </div>

                    <h3 className="text-xl font-bold text-white mb-2">Logout?</h3>
                    <p className="text-gray-400 text-sm mb-6">
                        Are you sure you want to logout? You will need to login again to access your account.
                    </p>

                    <div className="flex space-x-3">
                        <button
                            onClick={onClose}
                            disabled={isLoading}
                            className="flex-1 px-4 py-2.5 bg-gray-700 hover:bg-gray-600 text-white rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onConfirm}
                            disabled={isLoading}
                            className="flex-1 px-4 py-2.5 bg-red-500 hover:bg-red-600 text-white rounded-lg font-medium transition-all duration-300 shadow-lg shadow-red-500/20 disabled:opacity-70 disabled:cursor-not-allowed"
                        >
                            {isLoading ? (
                                <span className="flex items-center justify-center">
                                    <i className="ri-loader-4-line animate-spin mr-2"></i>
                                    Logouting...
                                </span>
                            ) : (
                                "Yes, Logout"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmLogoutModal;
